module.exports = "/_next/static/images/557b36c5d0aca3471c22363ef9b649c7-challenge-the-system-md@2x.jpg.webp";